import EditableTable from "../../Reusable/Table/EditableTable";
import { Tag, Button, Form, Modal, Image, Input, Select, message } from "antd";
import { EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
// import Model from "../../Reusable/Model/Model";
import { useState, useEffect } from "react";
import Loadingpage from "../Loadingpage/Loadingpage";
import "antd/dist/reset.css";
import axios from "axios";
import consts from "../../constant";
import ResuablText from "../../Reusable/TexrBreak/textbreak";

const Deposit = () => {
  const [selectedAssets, setSelectedAssets] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [totalPage, setTotalPage] = useState([]);
  const [page, setPage] = useState({ current: 1, pageSize: 10 });
  const [form] = Form.useForm();
  const status = Form.useWatch("status", form);
  const [assets, setAssets] = useState([]);
  const [total, setTotal] = useState(0);
  const [messageApi, contextHolder] = message.useMessage();
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    if (status === "approved" && selectedAssets) {
      form.setFieldValue("approwamount", selectedAssets.amount);
    }
    if (status !== "rejected") {
      form.setFieldValue("reason", "");
    }
  }, [status, selectedAssets]);

  const getDepositHistory = async (searchValue = search, filter = statusFilter) => {
    try {
      setLoading(true);
      const { data } = await axios.post(
        `${consts.BackendUrl}/users/get-deposit-history?page=${page.current}&limit=${page.pageSize}`,
        {
          status: filter,
          search: searchValue,
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );

      if (data?.success) {
        const mappedData = data.result.map((item, index) => ({
          key: item._id,
          sno: (page.current - 1) * page.pageSize + index + 1,
          Name: item.user_id?.name || "-",
          email: item.user_id?.email || "-",
          amount: item.amount || "-",
          approwamount: item.approved_amount || "-",
          Proof: item.url || item.reference || "https://picsum.photos/id/237/200/300.jpg",
          status: item.status || "-",
          reason: item.remarks || "-",
        }));
        setAssets(mappedData);
        setTotal(data.total);
      } else {
        setAssets([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Failed to fetch deposit history:", error);
      messageApi.error("Failed to fetch deposit history");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDepositHistory();
  }, [page.current, page.pageSize, search, statusFilter]);
  const { Search } = Input;
  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
    },

    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Approve Amount",
      dataIndex: "approwamount",
      key: "approwamount",
    },
    // {
    //   title: "Reason",
    //   dataIndex: "reason",
    //   key: "reason",
    //   render: (value) => value || "-",
    // },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: 500,
      // render: (value) => (
      //   <div style={{ wordBreak: "break-all", whiteSpace: "normal" }}>
      //     {value || "-"}
      //   </div>
      // ),
      render: (value) => <ResuablText text={value} limit={20} title="Reason" />,
    },
    {
      title: "Proof",
      dataIndex: "Proof",
      key: "Proof",
      render: (img) => (
        <Image
          width={30}
          src={img}
          preview={{
            styles: {
              mask: {
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(0,0,0,0.5)",
              },
            },
          }}
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        const statusMap = {
          approved: {
            text: "#4ade80", // soft green
            bg: "rgba(74, 222, 128, 0.12)",
          },
          pending: {
            text: "#facc15", // soft yellow
            bg: "rgba(250, 204, 21, 0.12)",
          },
          rejected: {
            text: "#f87171", // soft red
            bg: "rgba(248, 113, 113, 0.12)",
          },
        };

        const status = statusMap[value] || statusMap.rejected;

        return (
          <Tag
            style={{
              color: status.text,
              backgroundColor: status.bg,
              border: "none",
              borderRadius: "6px",
              fontWeight: 500,
              padding: "2px 10px",
            }}
          >
            {value?.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Action",
      key: "select",
      // fixed: "right",

      render: (_, record) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEditAsset(record)}
          disabled={record.status === "approved"}
          style={{
            opacity: record.status === "approved" ? 0.5 : 1,
            // cursor: record.status !== "pending" ? "not-allowed" : "pointer",
            color: "#2eff0c",
          }}
        >
          {record.status === "approved" ? "Verified" : "Edit"}
        </Button>
      ),
    },
  ];

  const handleEditAsset = (record) => {
    setSelectedAssets(record);
    setOpenDrawer(true);
    form.setFieldsValue({
      ...record,
      approwamount: record.amount,
      reason: record.reason === "-" ? "" : record.reason,
    });
  };
  const handlePagination = (pagination) => {
    console.log("Table params:", pagination);
    setPage(pagination);
  };
  const onFinish = async (values) => {
    try {
      setLoading(true);
      const { data } = await axios.post(
        `${consts.BackendUrl}/verify-deposit`,
        {
          id: selectedAssets.key,
          status: values.status,
          amount: values.approwamount,
          remark: values.reason || "",
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );

      if (data?.success) {
        messageApi.success(data.message || "Deposit updated successfully");
        onClose();
        getDepositHistory();
      } else {
        messageApi.error(data.message || "Failed to update deposit");
      }
    } catch (error) {
      console.error("Failed to update deposit:", error);
      messageApi.error(error.response?.data?.message || "Failed to update deposit");
    } finally {
      setLoading(false);
    }
  };

  const onClose = () => {
    setOpenDrawer(false);
    setSelectedAssets(null);
    form.resetFields();
  };

  const [searchText, setSearchText] = useState("");

  const clearFilters = () => {
    setSearch("");
    setSearchText("");
    setStatusFilter("all");
    // setPage({ current: 1, pageSize: 10 });
  };

  return (
    <div className="p-20">
      <Loadingpage />

      <div className="display-2 p-10">
        <h2>Deposit History</h2>
        <div className="display-1">
          <Search
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search for name"
            onSearch={(value) => {
              setPage({ current: 1, pageSize: 10 });
              setSearch(value);
            }}
            allowClear
            style={{ width: 200 }}
            // loading={confirmLoading}
            className="input-cls"
          />
          <div className="display-2">
            <Select
              allowClear
              style={{ width: 130 }}
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e || "all");
                setPage((prev) => ({ ...prev, current: 1 }));
              }}
              placeholder=" Select Status"
            >
              <Select.Option value={"all"}>All</Select.Option>
              <Select.Option value={"pending"}>Pending</Select.Option>
              <Select.Option value={"approved"}>Approved</Select.Option>
              <Select.Option value={"rejected"}>Rejected</Select.Option>
            </Select>
          </div>
          <div className="display-2">
            <Button onClick={clearFilters}>Clear</Button>
          </div>
        </div>
      </div>

      <EditableTable
        columnsConfig={userColumns}
        dataSource={assets}
        className="mt-20"
        total={total}
        pageSize={page?.pageSize ? page?.pageSize : 10}
        current={page?.current ? page?.current : 1}
        closeDisabled={true}
        onChange={handlePagination}
      />
      <Modal
        open={openDrawer}
        onClose={onClose}
        title="Deposit Details"
        extra={<CloseCircleOutlined className="cursor" onClick={onClose} />}
        onCancel={onClose}
        footer={null}
        centered
        maskClosable={false}
        maskStyle={{
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        }}
        styles={{
          content: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            color: "white",
          },
          header: {
            backgroundColor: "transparent",
          },
        }}
      >
        {selectedAssets?.status !== "approved" ? (
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <div style={{ marginBottom: "15px", color: "white" }}>
              <strong style={{ color: "#2eff0c" }}>Amount: </strong>
              <span>{selectedAssets?.amount || "-"}</span>
            </div>
            {status === "approved" && (
              <Form.Item
                label="Approve Amount"
                name="approwamount"
                rules={[
                  { required: true, message: "Please enter amount" },
                  () => ({
                    validator(_, value) {
                      if (!value || Number(value) > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Amount must be greater than 0"),
                      );
                    },
                  }),
                ]}
              >
                <Input type="number" />
              </Form.Item>
            )}
            <Form.Item label="Status" name="status">
              <Select placeholder="Select status">
                <Select.Option value="approved">Approve</Select.Option>
                <Select.Option value="rejected">Reject</Select.Option>
              </Select>
            </Form.Item>
            {status === "rejected" && (
              <Form.Item
                label="Reason"
                name="reason"
                rules={[
                  {
                    required: true,
                    message: "Please enter reason",
                  },
                ]}
              >
                <Input.TextArea
                  showCount={{
                    formatter: ({ count, maxLength }) => (
                      <span style={{ color: "white" }}>
                        {count}/{maxLength}
                      </span>
                    ),
                  }}
                  maxLength={100}
                  rows={4}
                  placeholder="Enter reason"
                />
              </Form.Item>
            )}
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Save
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div style={{ color: "white", padding: "20px" }}>
            <div style={{ marginBottom: "15px" }}>
              <strong style={{ color: "#2eff0c" }}>Amount: </strong>
              <span>{selectedAssets?.amount || "-"}</span>
            </div>
            <div style={{ marginBottom: "15px" }}>
              <strong style={{ color: "#2eff0c" }}>Approve Amount: </strong>
              <span>{selectedAssets?.approwamount || "0"}</span>
            </div>
            <div style={{ marginBottom: "15px" }}>
              <strong style={{ color: "#2eff0c" }}>Status: </strong>
              <span>
                {selectedAssets?.status === "approved" ? (
                  <Tag color="green">Approved</Tag>
                ) : (
                  <Tag color="red">Rejected</Tag>
                )}
              </span>
            </div>
            <div>
              <strong style={{ color: "#2eff0c" }}>Reason: </strong>
              <span>{selectedAssets?.reason || ""}</span>
            </div>
          </div>
        )}
      </Modal>
      {contextHolder}
    </div>
  );
};

export default Deposit;
